import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toggleSpinner } from 'apps/promo/actions/appAction';
import { toggleChat } from 'apps/promo/actions/chatAction';
import { CommonPagePromo } from 'apps/promo/components/common/CommonPagePromo';
import { LightDiskButton } from 'apps/promo/components/common/fromAuth/LightDiskButton/LightDiskButton';
import { LightHeaderPanel } from 'apps/promo/components/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'apps/promo/components/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'apps/promo/components/common/fromAuth/LightText/LightText';
import ZendeskHelpMobileSearch from 'apps/promo/components/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelpMobile.module.css';

const ZendeskHelpMobileSectionPage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const section = props.sections?.find((s) => s.id === sectionIdNumber);

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const articles = props.articles?.map((article) => {
        return (
            <a
                className={styles.mobileHelpLink}
                key={article.id}
                href={getHelpCenterUrl(`${url}/category/${props.category.id}/section/${sectionId}/article/${article.id}`, urlParams)}
            >
                <LightText>{article.name}</LightText>
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    return (
        <CommonPagePromo
            useThemeColor
            backUrl={section?.directLink ? null : getHelpCenterUrl(`${url}/category/${props.category.id}`, urlParams)}
            type={'tagA'}
            rightHeaderComponent={
                !urlParams.platform ? (
                    <LightDiskButton
                        type={'tagA'}
                        href={props.backUrl}
                        onClick={() => {
                            props.toggleSpinner(true);
                            sessionStorage?.removeItem('prevUrl');
                        }}
                        iconName={'cross'}
                    />
                ) : null
            }
        >
            <LightHeaderPanel useThemeColor title={section?.name} />
            <ZendeskHelpMobileSearch
                isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'}
                hasFixedIndent={urlParams.version === 'c3p0'}
            />
            {articles}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    articles: extra?.zendeskHelpData?.articles,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat, toggleSpinner })(NotAuthBasePage(ZendeskHelpMobileSectionPage));
